import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import { useIntl } from "react-intl";
import Toast from "../../helpers/Toast";


interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (motive: string) => void;
  taskTitle?: string;
  loading?: boolean;
}

const AssistanceChekListTaskObservationModalComponent: React.FC<Props> = ({ isOpen, onClose, onConfirm, taskTitle, loading = false }) => {
  const intl = useIntl();
  const [observation, setObservation] = useState("");

  const handleConfirm = () => {
  if (!observation.trim()) {
    Toast.Show("error", "Observação inválida. Por favor, preencha o campo das observações.");
    return;
  }
  onConfirm(observation);
};

  useEffect(() => {
    if (isOpen) setObservation("");
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md">
      <ModalHeader toggle={onClose}>
        {intl.formatMessage({ id: "Screens.AssistanceCheckList.ErrorModal.Title", defaultMessage: "Adicionar Observações" })}
      </ModalHeader>

      <ModalBody>
        <InputComponent
          xl={12} lg={12} md={12} sm={12} xs={12}
          type="text"
          value={taskTitle ?? ""}
          label={intl.formatMessage({ id: "Screens.AssistanceCheckList.TaskTitle", defaultMessage: "Tarefa" })}
          readOnly
        />

        <InputComponent
          xl={12} lg={12} md={12} sm={12} xs={12}
          type="textArea"
          value={observation}
          label={intl.formatMessage({ id: "Screens.AssistanceCheckList.ErrorModal.MotiveLabel", defaultMessage: "Por favor coloque aqui as suas observações" })}
          onChange={setObservation}
          readOnly={false}
        />
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          {intl.formatMessage({ id: "Common.Buttons.Cancel" })}
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={loading}>
          {loading ? <Spinner size="sm" /> : intl.formatMessage({ id: "Common.Buttons.Save" })}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssistanceChekListTaskObservationModalComponent;
